"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeaseTerm = function LeaseTerm() {
  return _react2.default.createElement(
    "g",
    { id: "leaseTerm" },
    _react2.default.createElement("path", {
      d: "M71.26 296.29h47.504v68.376h71.26v45.583h-71.26v68.372H71.26V410.25H0v-45.584h71.26V296.29zM261.277 0c130.64 0 237.53 102.562 237.53 227.917 0 125.354-106.89 227.916-237.53 227.916V410.25c104.513 0 190.023-82.05 190.023-182.333 0-100.284-85.51-182.334-190.022-182.334-104.512 0-190.023 82.05-190.023 182.334H23.75C23.75 102.562 130.636 0 261.277 0zm23.753 102.562v113.96h118.766v45.582h-166.27V102.562l.237-22.79h47.268v22.79z",
      id: "Shape"
    })
  );
};

exports.default = LeaseTerm;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/LeaseTerm.js
// module id = 2964
// module chunks = 4